import { defaultAccountsRepository } from "api/repositories/accounts/AccountsRepository";
import { LoginResponseModel } from "api/repositories/authentications/model/LoginResponseModel";
import { defaultPartnersRepository } from "api/repositories/partners/PartnersRepository";
import { PartnersResponse } from "api/repositories/partners/model/PartnersResponse";
import SidebarMenuConfigRepository from "api/repositories/sidebarMenu/SidebarMenuConfigRepository";
import { SidebarMenuConfigModel } from "api/repositories/sidebarMenu/model/SidebarMenuConfigModel";
import { isEmpty, isUndefined, set } from 'lodash';
import {
  Context,
  ReactNode,
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";
import { getMessage } from "utils/helpersInTs/helpersInTs";
import { strings } from "utils/localizedStrings";
import { ContextModel } from "./model/ContextModel";
import { defaultPathConfigRepository } from "api/repositories/pathConfig/PathConfigRepository";

export const LocalContext: Context<ContextModel> = createContext(
  new ContextModel()
);

export const ContextProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<LoginResponseModel>();
  const [partnerList, setPartnerList] = useState<PartnersResponse[]>([]);
  const history = useNavigate();
  const [info, setInfo] = useState("");
  const token = localStorage.getItem("token");
  const [config, setConfig] = useState({});

  const [menuConfig, setMenuConfig] =
    useState<SidebarMenuConfigModel>(undefined);

  const getRoles = useCallback(async () => {
    try {
      const { data } = await defaultAccountsRepository?.getUser();
      if (data) {
        setUser(data?.data);
        await getSidebar(data?.data?.isAdmin);
      }
    } catch (error) {
      console.log(error);
      localStorage?.clear();
      getMessage(strings.GlobalMessage.SystemError, 4, "error");
      history("/login");
    }
  }, [history]);

  const fetchPartnerList = async () => {
    try {
      const res = await defaultPartnersRepository.getPartnerList({
        page: 0,
        limit: 500,
      });
      if (res) {
        let data = [...res?.data?.data];
        setPartnerList(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getSidebar = useCallback(
    async (role: boolean) => {
      try {
        const siderConfig = await SidebarMenuConfigRepository?.getSidebarMenu(
          role
        );
        setMenuConfig(siderConfig?.data?.data);
        localStorage?.setItem("menu", JSON.stringify(siderConfig?.data?.data));
      } catch (error) {
        console.log(error);
      }
    },
    [user]
  );

  const getPartnerInfo = (value: any) => {
    setInfo(value);
  };

  useEffect(() => {
    if (!isEmpty(token) && !isUndefined(token)) {
      getRoles();
    }
  }, [token]);

  const isAuthenticated = () => {
    return !!token;
  };

  const getConfig = async () => {
    try {
      const res = await defaultPathConfigRepository?.configDetail("b2c-cms-config");
      if (res?.data) {
        setConfig(JSON.parse(res?.data?.data?.config as string));
      }
    } catch (error) {
      console.error(error);
    }
  };


return (
  <LocalContext.Provider
    value={{
      user: user,
      getPartnerInfo: getPartnerInfo,
      info,
      menuConfig,
      partnerList,
      setPartnerList,
      getRoles,
      getSidebar,
      isAuthenticated,
      getConfig,
      config
    }}
  >
    {children}
  </LocalContext.Provider>
);
};

export const AuthenticationContext = () => useContext(LocalContext);
